// @flow
import type {Element, Node} from 'react'
import React from 'react'
import className from 'classnames'

import styles from './index.scss'

type Props = {
  children: Node,
  id: string,
  name: ?string,
  layout?: 'classic' | 'workspace' | 'none',
  'test-id'?: string,
}

function Layout({children, id, name, layout, 'test-id': testId}: Props): Element<"div"> {
  const layoutClassName = className({
    [styles.classicLayout]: layout === 'classic',
    [styles.workspaceLayout]: layout === 'workspace',
  })

  return (
    <div id={id} className={layoutClassName} aria-label={name} test-id={testId}>
      {children}
    </div>
  )
}

Layout.defaultProps = {
  name: null,
  layout: 'classic',
  'test-id': '',
}

export default Layout
